export default {
  namespaced: true,
  state: {
    isShowArtifactList: false,
    selectedCity: { code: '440000', value: '全省' },
    selectCategorieUid: [],
    selectCategorieName: '',
    moreOptionsId: [],
    selectedLine: { line: '不限' },
    selectedDistrict: { name: '不限' }
  },
  getters: {
    isShowArtifactList: state => state.isShowArtifactList,
    selectedCity: state => state.selectedCity,
    selectCategorieName: state => state.selectCategorieName,
    selectCategorieUid: state => state.selectCategorieUid,
    moreOptionsId: state => state.moreOptionsId,
    selectedLine: state => state.selectedLine,
    selectedDistrict: state => state.selectedDistrict
  },
  mutations: {
    setIsShowArtifactList (state, status) {
      state.isShowArtifactList = status
    },
    setSelectedCity (state, params) {
      state.selectedCity = params
    },
    setSelectedDistrict (state, params) {
      state.selectedDistrict = params
    },
    setSelectedLine (state, params) {
      state.selectedLine = params
    },
    setMoreOptionsId (state, params) {
      if (state.moreOptionsId.indexOf(params) === -1) {
        state.moreOptionsId = [params]
      }
    },
    setMoreOptionsIdByArr (state, params) {
      state.moreOptionsId = params
    },
    setSelectCategorieUid (state, params) {
      if (state.selectCategorieUid.indexOf(params) === -1) {
        state.moreOptionsId = []
        state.selectCategorieUid = [params]
      }
    },
    setSelectCategorieName (state, params) {
      state.selectCategorieName = params
    }
  },
  actions: {}
}
